export enum DocumentCategory {
  EITransition = 1,
  Evaluations = 2,
  IEP = 3,
  Placement = 4,
  Referral = 5,
  Student = 6,
  NursingReferral = 7,
  ProviderManagement = 8,
  Encounter = 9,
  Assessment = 10,
  NotSpecified = 999
}